import React from 'react';
import {
  Box, Link, Typography,
} from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import { DigitalSection } from '../../../redux/types';

type Props = {
  selectedSection: DigitalSection;
};

const ReferenceLinks: React.FC<Props> = ({
  selectedSection,
}: Props) => (
  <Box>
    {
      selectedSection.referenceLinks?.map((rl, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <Box key={i} display="flex" alignItems="center">
          <Link href={rl.link} target="_blank" rel="noopener noreferrer" underline="none" display="flex" alignItems="center">
            <LinkIcon />
            &nbsp;
            {rl.label}
          </Link>
          <Typography sx={{ mx: 1, wordBreak: 'break-all' }} variant="body2" color="GrayText">
            {rl.link}
          </Typography>
        </Box>
      ))
    }
  </Box>
);

export default ReferenceLinks;
